import React from 'react';
import i18n from 'i18next';

/** Спиннер, показывается при загрузке */
class Spinner extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className='text-center'>
				<div className='spinner-border text-primary' role='status'>
					<span className='sr-only'>{i18n.t('app.loading')}</span>
				</div>
				<div>{this.props.text}</div>
			</div>
		);
	}

}

export default Spinner;
